import { render, staticRenderFns } from "./PaySlipDetails.vue?vue&type=template&id=1b88415c&scoped=true&"
import script from "./PaySlipDetails.vue?vue&type=script&lang=js&"
export * from "./PaySlipDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaySlipDetails.vue?vue&type=style&index=0&id=1b88415c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88415c",
  null
  
)

export default component.exports